import { MACRO_KEY } from "../../defaults";

export const WIDGET_COSMOS_IDS = {
  [MACRO_KEY.UPCOMING_BIRTHDAYS]: "important-dates",
  [MACRO_KEY.WORK_ANNIVERSARY]: "work-aniversary-main",
  [MACRO_KEY.NEW_STARTERS]: "new-starters",
};
